<template lang="es">
<div class="profile">
    <Navigation></Navigation>

    <div class="container add_top_30 add_bottom_30">
        <div class="row">
			
            <Loader :show="saving" ></Loader>

            <div class="col col-lg-3">
                
                <ProfileSidebar></ProfileSidebar>

            </div>
            
            <div class="col-md-12 col-lg-9" v-if="loading" >
                <Loader :show="loading" type="inline"></Loader>
            </div>

			<div class="col-md-12 col-lg-9" v-if="!loading" >
                <div class="container box_general">
                    <div class="header_box">
                        <h2><i class="pe-7s-date"></i>Reserva #{{booking.code}}</h2>
                        <h4>
                            <span class="badge badge-warning" v-if="booking.status=='AWAITING_PAYMENT'">Pendiente de pago</span>
                            <span class="badge badge-danger" v-if="booking.status=='FAILED_PAYMENT'">Pago rechazado</span>
                            <span class="badge badge-light" v-if="booking.status=='REFUNDED_PAYMENT'">Pago devuelto</span>
                            <span class="badge badge-success" v-if="booking.status=='CONFIRMED'">Confirmada</span>
                            <span class="badge badge-success" v-if="booking.status=='VIDEO_LIVE'">VideoConsulta en curso</span>
                            <span class="badge badge-light" v-if="booking.status=='DONE' || booking.status=='VIDEO_ENDED'">Realizada</span>
                            <span class="badge badge-danger" v-if="booking.status=='CANCELLED_BY_USER'">Pendiente de devolución</span>
                            <span class="badge badge-danger" v-if="booking.status=='CANCELLED_BY_MEDIC'">Cancelada</span>
                            <span class="badge badge-danger" v-if="booking.status=='CANCELLED'">Cancelada</span>
                            <span class="badge badge-warning" v-if="booking.status=='RECLAIMED'">Reclamada</span>
                            <span class="badge badge-info" v-if="booking.status=='MEDIC_REQUEST_RESCHEDULE'">Reagenda solicitada</span>
                        </h4>

                    </div>

                    <div class="col-12 mt-3">

                        <div v-if="booking.userCanReschedule && booking.status=='MEDIC_REQUEST_RESCHEDULE' && !scheduleForm.open" class="alert alert-warning d-flex justify-content-between align-items-center">
                            <p class="m-0">
                                El médico ha solicitado que reagende su reserva para otra fecha disponible.<br> 
                            </p>
                            <a class="btn btn-warning" href="#" @click="openReschedule">Reagendar</a>
                        </div>

                        <div class="alert alert-warning" v-if="payPendingAlertShow">
                            <h4 class="alert-heading">Su reserva se encuetra pendiente de pago. </h4>
                            Si no realiza el pago antes dentro de las 24 horas posteriores a la solicitud de reserva, se cancelará automáticamente.
                            <hr>
                            
                            <Payment :amount="booking.price" :datetime="booking.timeslot.datetime" ref="PaymentComponent" @paymentDone="paymentDone" @paymentClosed="paymentClosed"></Payment>
                            
                            <div class="alert-footer">
                                <button class="btn btn-success pull-right" @click="retryPayment">Reintentar pago</button>
                            </div>
                        </div>

                        <div class="alert alert-warning" v-if="booking.status=='CANCELLED_BY_MEDIC' && !scheduleForm.open && booking.userCanReschedule">
                            <h4 class="alert-heading">Su reserva se ha sido cancelada. </h4>
                            Puede reagendar con el mismo médico para fecha o cancelar la reserva y le reembolsaremos el pago.
                            <hr>
                            <div class="alert-footer">
                                <button class="btn btn-link btn-xs mt-2" @click="bookingRefund">Solicitar devolución</button>
                                <button class="btn btn-success pull-right" @click="openReschedule" >Re Agendar</button>
                            </div>
                        </div>
                        
                        <div class="alert alert-warning" v-if="booking.status=='CANCELLED_BY_MEDIC' && !scheduleForm.open && !booking.userCanReschedule">
                            <h4 class="alert-heading">Su reserva se ha sido cancelada. </h4>
                        </div>

                    </div>


                    <div class="row" v-if="!scheduleForm.open" >
                        
                        <div class="col-md-8" >
                            <div class="book-data" >
                                <div class="box">
                                    <div class="subtitle">ESPECIALIDAD</div>
                                    <div class="value">
                                        {{booking.medicEspeciality.especiality.name }}
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="subtitle">FECHA Y HORA</div>
                                    <div class="value">
                                        <div class="date">{{booking.timeslot.datetime | moment("dddd DD [de] MMMM HH:mm")}}</div>
                                    </div>
                                </div>
                                
                                <div class="box" v-if="booking.channel=='presential'">
                                    <div class="subtitle">UBICACIÓN</div>
                                    <div class="value">
                                        <span v-if="this.booking.status == 'CONFIRMED'" >{{booking.medicBusinessAddress.street}} {{booking.medicBusinessAddress.number}} <br></span>
                                        <small> {{booking.medicBusinessAddress.locality.name}}, {{booking.medicBusinessAddress.locality.region.name}} </small>
                                    </div>
                                </div>

                                <div class="box">
                                    <div class="subtitle">Costo de la consulta</div>
                                    <div class="value">
                                        $ {{booking.price}}
                                    </div>
                                </div>
                                <div class="box" v-if="booking.comments">
                                    <div class="subtitle">HISTORIA</div>
                                    <div class="value">
                                        <p>{{booking.comments}}</p>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div class="col-md-4">
                            <div class="medic-info">
                                <figure class="mb-3">
                                    <div class="avatar" v-if="booking.medic.picture" :style="'background-image:url('+API_URL+booking.medic.picture.url+')'"></div>
                                    <div class="avatar" v-if="!booking.medic.picture && booking.medic.gender=='Dra.'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                                    <div class="avatar" v-if="!booking.medic.picture && booking.medic.gender!='Dra.'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>
                                </figure>
                                
                                <div class="especialities">
                                    <small  v-for="medicEspeciality in booking.medic.medicEspecialities" :key="medicEspeciality.id">
                                        {{medicEspeciality.especiality.name}}
                                    </small>
                                </div>
                                
                                <h1>{{booking.medic.fullname}}</h1>
                                
                                <div v-if="booking.medic.rate>0">
                                    <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="booking.medic.rate"  inactive-color="#ddd" :inline="true"></star-rating>
                                </div>
                            </div>
                        </div>

                        <div class="col-12" v-if="booking.payments.length>0">
                            <div class="book-data" >
                                <div class="box">
                                    <div class="subtitle">PAGOS</div>

                                    <ul class="payments">
                                        <li v-for="payment in booking.payments" :key="payment.pw_purchase_id">
                                            <div class="brand-logo" v-if="payment.pay_method">
                                                <img :src="require(`@/assets/img/icon-payment-${payment.pay_method.toLowerCase()}.png`)" class="img-fluid">
                                            </div>
                                            <div class="content">
                                                <h2 v-if="payment.card_last_numbers">Tarjeta terminada en {{payment.card_last_numbers}}</h2>
                                                <h2 v-else>Cupón de pago</h2>
                                                <h3>
                                                    <span v-if="payment.pay_method=='BANK'" >Transferencia bancaria </span>
                                                    <span v-if="payment.pw_purchase_id" >#{{payment.pw_purchase_id}} - </span>
                                                    <span v-if="payment.pw_transaction_status==1" class="text-success">Pago aprobado</span>
                                                    <span v-if="payment.pw_transaction_status==2" class="text-warning">Pago pendiente</span>
                                                    <span v-if="payment.pw_transaction_status==3" class="text-warning">Pago pre-autorizado</span>
                                                    <span v-if="payment.pw_transaction_status==4" class="text-danger">Pago rechazado</span>
                                                </h3>
                                            </div>
                                            <div class="date">
                                                {{payment.created_at | moment('DD/MM/YY HH:mm:ss')}}
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>




                        
                        <div class="col-12" >
                            
                            <div v-if="booking.userCanReschedule && booking.status!='MEDIC_REQUEST_RESCHEDULE'">
                                <p>
                                    Si desea reagendar esta reserva haga <a href="#" @click="openReschedule">click aquí</a>
                                </p>
                            </div>
                            
                            
                            <div v-if="!payPendingAlertShow && booking.userCanRetryPay" >
                                <p>
                                    <button class="btn btn-success pull-right" @click="payPendingAlertShow =true">Reintentar con otro medio de pago</button>
                                </p>
                            </div>

                            <div class="alert alert-warning" v-if="booking.status == 'CONFIRMED' && booking.userCanCancel">
                                Si el médico no se presentó a la consulta podés generar el reclamo haciendo <a href="#" @click="bookingReclaim">click aquí.</a>
                            </div>


                        </div>

                        <hr>

                        <div class="col-12 mt-4">
                            <router-link tag="button" :to="`/bookings/${booking.id}/attend`" 
                                class="btn btn-success pull-right video"  
                                v-if="booking.channel=='video' && booking.timeslot.datetime<now && ( booking.status=='CONFIRMED' || booking.status=='VIDEO_LIVE')">
                                    Ingresar a la VideoConsulta
                            </router-link>
                            
                            <router-link tag="button" :to="`/bookings/${booking.id}/rate`" 
                                class="btn btn-warning pull-right "  
                                v-if="booking.userCanRate">
                                    Calificar consulta
                            </router-link>

                            <router-link tag="button" class="btn btn-sm pull-left" to="/bookings">Volver</router-link>
                        </div>
                    </div>


                    <div class="row" v-if="scheduleForm.open">
                        <div class="col-md-8">
                            <div class="mt-3">
                                <h5>Reagendar consulta de {{booking.medicEspeciality.especiality.name }}</h5><br>
                                <h6>
                                    Seleccione una nueva fecha y confirme el cambio.
                                </h6>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="medic-info">
                                <figure class="mb-3">
                                    <div class="avatar" v-if="booking.medic.picture" :style="'background-image:url('+API_URL+booking.medic.picture.url+')'"></div>
                                    <div class="avatar" v-else :style="'background-image:url('+require('@/assets/img/no-avatar-image.gif')+')'"></div>
                                </figure>
                                <div class="especialities">
                                    <small  v-for="medicEspeciality in booking.medic.medicEspecialities" :key="medicEspeciality.id">
                                        {{medicEspeciality.especiality.name}}
                                    </small>
                                </div>
                                <h1>{{booking.medic.fullname}}</h1>
                                
                                
                                <div v-if="booking.medic.rate>0">
                                    <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="booking.medic.rate"  inactive-color="#ddd" :inline="true"></star-rating>
                                </div>

                            </div>
                        </div>

                        <div class="col-12"  >
                            <Calendar 
                                v-if="booking.medic.id" 
                                :medicId="booking.medic.id" 
                                :activeChannel="booking.channel"
                                @selected="selectHour"
                                ></Calendar>
                        </div>

                        <div class="col-12">

                            <div class="buttons mt-3 mb-3">
                                <button class="btn btn-light pull-left" @click="scheduleForm.open=false">
                                    Volver
                                </button>
                                <button class="btn btn-success pull-right" @click="saveReschedule">
                                    Confirmar cambio de hora
                                </button>
                            </div>
                            <p v-if="booking.userCanCancel">
                                <br>
                                Si ninguna hora te resulta conveniente, puede cancelar esta reserva y agendar con otro especialista haciendo <a href="#" @click="bookingCancel">click aquí</a>
                            </p>
                        </div>
                    </div>


                </div>

            </div>

        </div>
        
    </div>
    

    <!-- <BookingPreview ref="BookingPreview"></BookingPreview> -->

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation'
import ProfileSidebar from '@/components/ProfileSidebar'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
import Calendar from '@/components/Calendar'
import Payment from '@/components/Payment'

export default {
	name: 'bookingDetail',
	metaInfo() {
		return {
			title: 'Reserva # ' + this.booking.code,
		}
	},
	components: {
		Navigation,
		Footer,
		Loader,
		ProfileSidebar,
		Calendar,
		Payment,
	},
	data() {
		return {
			action: this.$route.query.action,
			loading: true,
			saving: false,
			booking: {},
			previewPane: {
				show: false,
				data: {
					id: '',
				},
			},
			scheduleForm: {
				open: false,
				slot: {},
			},
			API_URL: process.env.VUE_APP_API_URL,
			payPendingAlertShow: false,
			now: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
		}
	},
	computed: {
		...mapGetters(['isAuthenticated', 'loggedUser']),
	},
	methods: {
		openReschedule() {
			this.scheduleForm.open = true
		},

		selectHour(selectedSlot) {
			this.scheduleForm.slot = selectedSlot
		},

		retryPayment() {
			this.saving = true
			let paymentValidate = this.$refs.PaymentComponent.validate()

			if (paymentValidate.valid) {
				this.$refs.PaymentComponent.proccess(this.booking)
			} else {
				this.saving = false
				this.$toast.error(paymentValidate.err)
			}
		},

		paymentDone(bookingCode, data) {
			if (!bookingCode) {
				alert(data)
				this.saving = false
			} else {
				console.log('PaymentDone', bookingCode, data)
				this.$router.push('/checkout/' + bookingCode + '/payment')
			}
		},

		paymentClosed(paying) {
			console.log('paymentClosed on Booking detail', paying)
			if (!paying) {
				this.saving = false
			}
		},

		bookingRefund() {
			this.$dialog
				.confirm({
					title: 'Solicitar devolución',
					body: '¿Estás seguro que no deséas reagendar tu consulta y solicitar la devolución del dinero?',
				})
				.then(() => {
					if (!this.saving && this.booking.id > 0) {
						this.saving = true

						this.$apollo
							.mutate({
								mutation: gql`
									mutation($id: ID!) {
										bookingCancelByUser(id: $id) {
											id
											status
										}
									}
								`,
								variables: {
									id: this.booking.id,
								},
							})
							.then(() => {
								this.$apollo.queries.me.refetch()
								this.$toast.success('Devlución solicitada')

								this.saving = false
							})
							.catch(() => {
								this.$toast.error('Oops!')
								this.saving = false
							})
					}
				})
				.catch(() => {
					console.log('Clicked on cancel')
					this.saving = false
				})
		},

		bookingReclaim() {
			this.$dialog
				.confirm({
					title: 'Reclamar consulta',
					body: 'A la brevedad nos comunicaremos contigo.',
				})
				.then(() => {
					if (!this.saving && this.booking.id > 0) {
						this.saving = true

						this.$apollo
							.mutate({
								mutation: gql`
									mutation($id: ID!) {
										bookingReclaim(id: $id) {
											id
											status
										}
									}
								`,
								variables: {
									id: this.booking.id,
								},
							})
							.then(() => {
								this.$toast.success('Consulta reclamada')
								this.$apollo.queries.me.refetch()
								this.saving = false
							})
							.catch(() => {
								this.$toast.error('Oops!')
								this.saving = false
							})
					}
				})
				.catch(() => {
					console.log('Clicked on cancel')
					this.saving = false
				})
		},

		bookingCancel() {
			this.$dialog
				.confirm({
					title: 'Cancelar consulta',
					body: 'A la brevedad nos comunicaremos contigo.',
				})
				.then(() => {
					if (!this.saving && this.booking.id > 0) {
						this.saving = true

						this.$apollo
							.mutate({
								mutation: gql`
									mutation($id: ID!) {
										bookingCancelByUser(id: $id) {
											id
											status
										}
									}
								`,
								variables: {
									id: this.booking.id,
								},
							})
							.then(() => {
								this.$toast.success('Consulta reclamada')
								this.$router.push('/doctors/' + this.booking.medicEspeciality.especiality.slug)
								this.saving = false
							})
							.catch(() => {
								this.$toast.error('Oops!')
								this.saving = false
							})
					}
				})
				.catch(() => {
					console.log('Clicked on cancel')
					this.saving = false
				})
		},

		saveReschedule() {
			if (!this.saving) {
				this.saving = true

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($id: ID!, $timeslot_id: ID!) {
								bookingReschedule(id: $id, timeslot_id: $timeslot_id) {
									code
									status
								}
							}
						`,
						variables: {
							id: this.booking.id,
							timeslot_id: this.scheduleForm.slot.id,
						},
					})
					.then(() => {
						this.saving = false
						this.scheduleForm.open = false
						this.$apollo.queries.me.refetch()
						this.$toast.success('Reserva reagendada')
					})
					.catch((error) => {
						console.log(error)
						this.$toast.error('Ha ocurrido un error, intentar nuevamente mas tarde')
						this.saving = false
					})
			}
		},
	},
	apollo: {
		me: {
			query: gql`
				query($id: ID!) {
					me {
						booking(id: $id) {
							id
							code
							price
							channel
							status
							comments
							user {
								email
								doc_type
								doc_number
							}
							medicEspeciality {
								title
								especiality {
									name
									slug
								}
							}
							medic {
								id
								fullname
								prefix
								gender
								picture {
									url
								}
								medicEspecialities {
									id
									title
									university
									description
									price
									status
									especiality {
										name
									}
									medicSubespecialities {
										subespeciality {
											name
										}
									}
								}
								rate
							}
							timeslot {
								datetime
								status
							}
							payments {
								currency
								amount
								pw_purchase_id
								pw_transaction_status
								pay_method
								card_last_numbers
								created_at
							}
							medicBusinessAddress {
								street
								number
								locality {
									name
									region {
										name
									}
								}
							}
							is_donated
							userCanCancel
							userCanPay
							userCanRetryPay
							userCanReschedule
							userCanRate
						}
					}
				}
			`,
			fetchPolicy: 'no-cache',
			variables() {
				return {
					id: this.$route.params.id,
				}
			},
			result(data) {
				//si la reserva fue cancelada pr el medico Y tiene el flag de reagendar, abro directamente la reangenda.

				this.booking = data.data.me.booking[0]
				if (!this.booking) {
					this.$router.push('/bookings')
				}
				if (this.booking.status == 'CANCELLED_BY_MEDIC' && this.booking.userCanReschedule) {
					this.openReschedule()
				}
				this.payPendingAlertShow =
					(this.booking.status == 'FAILED_PAYMENT' && this.booking.userCanRetryPay) ||
					(this.booking.status == 'AWAITING_PAYMENT' && this.booking.userCanRetryPay && this.booking.payments.length == 0)
				this.loading = false
			},
		},
	},
}
</script>

<style scoped>
.book-data {
	width: 100%;
}
.book-data .box {
	padding: 12px 8px;
}
.book-data .box:not(:last-child) {
	border-bottom: solid 1px #ededed;
}
.book-data .box .subtitle {
	font-size: 12px;
	text-transform: uppercase;
	color: #666;
}
.book-data .box .value {
	font-size: 18px;
	text-transform: capitalize;
	line-height: 18px;
}
.book-data .box .value p {
	font-size: 14px;
	text-transform: none;
	line-height: 14px;
}

.medic-info {
	border-left: solid 1px #ededed;
	padding: 18px;
	text-align: center;
}
.medic-info figure {
	width: 90px;
	margin: auto;
	border-radius: 45px;
	overflow: hidden;
}

.medic-info .rating {
	margin-bottom: 20px;
	display: inline-block;
}

.medic-info small {
	text-transform: uppercase;
	color: #999;
	font-weight: 600;
}

.medic-info h1 {
	font-size: 18px;
}

.actions-box {
	border-top: 1px solid #ededed;
	width: 100%;
	padding: 12px 8px;
}

.payments {
}
.payments li {
	width: 100%;
	padding: 8px;
	border-bottom: solid 1px #ededed;
	display: flex;
	align-items: center;
}
.payments .brand-logo {
	margin-right: 8px;
	max-width: 120px;
}

.payments h2 {
	font-size: 14px;
	font-weight: 600;
	margin: 0px;
}
.payments h3 {
	font-size: 14px;
	font-weight: 400;
	margin: 0px;
	color: #666;
}
.payments h3 span {
	font-weight: 400;
}
.payments .date {
	flex-grow: 1;
	text-align: right;
	color: #999;
	font-size: 12px;
}
</style>
